import {
  Zap,
  Bot,
  House,
  Search,
  Settings,
  FileText,
  Shield,
  Shapes,
  Store,
} from "lucide-react";

import { Env } from "@/shared/environment";
import { Goto } from "@/shared/navigation/Goto";

export interface NavGroups {
  features: NavLink[];
  settingsAndGuides: NavLink[];
  admin: NavLink[];
}

export interface NavLink {
  name: string;
  link: string;
  icon: React.ElementType;
  isExternalLink?: boolean;
}

export const navGroups: NavGroups = {
  features: [
    {
      name: "Home",
      link: Goto.route.Home,
      icon: House,
    },
    {
      name: "Search",
      link: Goto.route.Search,
      icon: Search,
    },
    {
      name: "Actions",
      link: "/actions",
      icon: Zap,
    },
    {
      name: "Action Hub",
      link: Goto.route.ActionHub,
      icon: Store,
    },
    {
      name: "Collections",
      link: Goto.route.Collections,
      icon: Shapes,
    },
    {
      name: "Devices",
      link: Goto.route.Devices,
      icon: Bot,
    },
  ],
  settingsAndGuides: [
    {
      name: "Settings",
      link: Goto.route.Settings,
      icon: Settings,
    },
    {
      name: "Docs",
      isExternalLink: true,
      link: `https://${Env.docsDomain}`,
      icon: FileText,
    },
  ],
  admin: [
    {
      name: "Admin",
      link: Goto.route.Admin,
      icon: Shield,
    },
  ],
};
